import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import MediaQuery from 'react-responsive';
import Select from "react-dropdown-select";
import ReactGA from 'react-ga';

import RequestModal from '../../RequestModal';

import FoundationalBundleImg2x from '../../../assets/img/solution01@2x.png';
import ExpandBundleImg2x from '../../../assets/img/solution02@2x.png';
import EnterpriseBundleImg2x from '../../../assets/img/solution03@2x.png';

import styles from './BundlesScreen.module.css';
import { REQUEST_PRICE_FOUNDATIONAL, REQUEST_PRICE_EXPAND, REQUEST_PRICE_ENTERPRISE } from '../../../utils/constants';

const BundlesScreen = (props) => {
  const { showModal } = props;
  const { formatMessage } = useIntl();

  const [ selectedBundle, setSelectedBundle ] = useState('foundational');
  const selectOptions = [
    {
      label: formatMessage({id: 'BundlesScreen.Foundational.title'}),
      value: 'foundational',
    },
    {
      label: formatMessage({id: 'BundlesScreen.Expand.title'}),
      value: 'expand',
    },
    {
      label: formatMessage({id: 'BundlesScreen.Enterprise.title'}),
      value: 'enterprise',
    },
  ];

  const htmlHandlers = {
    ul: (str) => <ul>{str}</ul>,
    li: (str) => <li key={Math.random()}>{str}</li>,
  }

  return (
    <div className={styles.container} id="choose-bundle">
      <div className={`${styles.title} Rubik-60pt`}>
        {formatMessage({id: 'BundlesScreen.title'})}
      </div>
      <div className={`${styles.description} Rubik-26pt`}>
        {formatMessage({id: 'BundlesScreen.description'})}
      </div>
      <MediaQuery minDeviceWidth={1224}>
        <div className={styles.bundles}>
          <div className={styles.bundle}>
            <div className={`${styles['bundle-title']} Rubik-40pt`}>
              {formatMessage({id: 'BundlesScreen.Foundational.title'})}
            </div>
            <div className={`${styles['bundle-meta']} Rubik-26pt`}>
              {formatMessage({id: 'BundlesScreen.Foundational.meta'})}
            </div>
            <div className={`${styles['bundle-bullets']} Rubik-26pt`}>
              <ul>
                {formatMessage({id: 'BundlesScreen.Foundational.bullets'}, htmlHandlers)}
              </ul>
            </div>
          </div>
          <div className={styles.bundle}>
            <div className={`${styles['bundle-title']} Rubik-40pt`}>
              {formatMessage({id: 'BundlesScreen.Expand.title'})}
            </div>
            <div className={`${styles['bundle-meta']} Rubik-26pt`}>
              {formatMessage({id: 'BundlesScreen.Expand.meta'})}
            </div>
            <div className={`${styles['bundle-bullets']} Rubik-26pt`}> 
              <ul>
                {formatMessage({id: 'BundlesScreen.Expand.bullets'}, htmlHandlers)}
              </ul>
            </div>
          </div>
          <div className={styles.bundle}>
            <div className={`${styles['bundle-title']} Rubik-40pt`}>
              {formatMessage({id: 'BundlesScreen.Enterprise.title'})}
            </div>
            <div className={`${styles['bundle-meta']} Rubik-26pt`}>
              {formatMessage({id: 'BundlesScreen.Enterprise.meta'})}
            </div>
            <div className={`${styles['bundle-bullets']} Rubik-26pt`}>
              <ul>
                {formatMessage({id: 'BundlesScreen.Enterprise.bullets'}, htmlHandlers)}
              </ul>
            </div>
          </div>
        </div>
        <div className={styles['bundle-descriptions']}>
          <div className={styles['bundle-description']}>
            <div className={styles['bundle-image']}>
              <img
                src={FoundationalBundleImg2x}
                alt="Foundational platform"/>
            </div>
            <div className={styles['bundle-description-wrapper']}>
              <div className={`${styles['bundle-description-title']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.subtitle'})}
              </div>
              <div className={`${styles['bundle-description-body']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.body'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.motherboard'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.motherboard.description'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.cpu'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.cpu.description'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.ram'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.ram.description'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.storage'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.storage.description'})}
              </div>
              <div className={styles['bundle-ask-price-container']}>
                <button className={`${styles['bundle-ask-price']} Rubik-20pt`} onClick={() => {
                  ReactGA.set({ dimension4: REQUEST_PRICE_FOUNDATIONAL });
                  showModal(RequestModal, {
                      selectedBusiness: {
                        type: 1,
                        title: 'Foundational',
                      }
                    });
                }}>
                  {formatMessage({id: 'BundlesScreen.RequestPrice'})}
                </button>
              </div>
            </div>
          </div>
          <div className={styles['bundle-description']}>
            <div className={styles['bundle-image']}>
              <img src={ExpandBundleImg2x} alt="Expand platform"/>
            </div>
            <div className={styles['bundle-description-wrapper']}>
              <div className={`${styles['bundle-description-title']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.subtitle'})}
              </div>
              <div className={`${styles['bundle-description-body']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.body'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.motherboard'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.motherboard.description'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.cpu'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.cpu.description'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.ram'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.ram.description'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.storage'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.storage.description'})}
              </div>
              <div className={styles['bundle-ask-price-container']}>
                <button className={`${styles['bundle-ask-price']} Rubik-20pt`} onClick={() => {
                  ReactGA.set({ dimension5: REQUEST_PRICE_EXPAND });
                  showModal(RequestModal, {
                      selectedBusiness: {
                        type: 2,
                        title: 'Expand',
                      }
                    });
                }}>
                  {formatMessage({id: 'BundlesScreen.RequestPrice'})}
                </button>
              </div>
            </div>
          </div>
          <div className={styles['bundle-description']}>
            <div className={styles['bundle-image']}>
              <img src={EnterpriseBundleImg2x} alt="Enterprise platform"/>
            </div>
            <div className={styles['bundle-description-wrapper']}>
              <div className={`${styles['bundle-description-title']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.subtitle'})}
              </div>
              <div className={`${styles['bundle-description-body']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.body'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.motherboard'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.motherboard.description'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.cpu'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.cpu.description'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.ram'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.ram.description'})}
              </div>
              <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.storage'})}
              </div>
              <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.storage.description'})}
              </div>
              <div className={styles['bundle-ask-price-container']}>
                <button className={`${styles['bundle-ask-price']} Rubik-20pt`} onClick={() => {
                  ReactGA.set({ dimension6: REQUEST_PRICE_ENTERPRISE });
                  showModal(RequestModal, {
                      selectedBusiness: {
                        type: 3,
                        title: 'Entry-level Enterprise',
                      }
                    });
                }}>
                  {formatMessage({id: 'BundlesScreen.RequestPrice'})}
                </button>
              </div>
            </div>
          </div>
        </div>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={1224}>
        <div className={styles['dropdown-container']}>
          <Select
            options={selectOptions}
            labelField="label"
            valueField="value"
            className={`${styles.dropdown} Rubik-26pt`}
            onChange={e => setSelectedBundle(e[0]?.value)}
            values={[selectOptions[0]]}
          />
        </div>
        { selectedBundle === 'foundational' && (
          <>
            <div className={styles.bundle}>
              <div className={`${styles['bundle-meta']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Foundational.meta'})}
              </div>
              <div className={`${styles['bundle-bullets']} Rubik-26pt`}>
                <ul>
                  {formatMessage({id: 'BundlesScreen.Foundational.bullets'}, htmlHandlers)}
                </ul>
              </div>
            </div>
            <div className={styles['bundle-description']}>
              <div className={styles['bundle-image']}>
                <img
                  src={FoundationalBundleImg2x}
                  alt="Foundational platform"/>
              </div>
              <div className={styles['bundle-description-wrapper']}>
                <div className={`${styles['bundle-description-title']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.subtitle'})}
                </div>
                <div className={`${styles['bundle-description-body']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.body'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.motherboard'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.motherboard.description'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.cpu'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.cpu.description'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.ram'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.ram.description'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.storage'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Foundational.storage.description'})}
                </div>
                <div className={styles['bundle-ask-price-container']}>
                  <button className={`${styles['bundle-ask-price']} Rubik-20pt`} onClick={() => {
                    ReactGA.set({ dimension4: REQUEST_PRICE_FOUNDATIONAL });
                    showModal(RequestModal, {
                      selectedBusiness: {
                        type: 1,
                        title: 'Foundational',
                      }
                    })
                  }}>
                    {formatMessage({id: 'BundlesScreen.RequestPrice'})}
                  </button>
                </div>
              </div>
            </div>
          </>
        ) }
        { selectedBundle === 'expand' && (
          <>
            <div className={styles.bundle}>
              <div className={`${styles['bundle-meta']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Expand.meta'})}
              </div>
              <div className={`${styles['bundle-bullets']} Rubik-26pt`}> 
                <ul>
                  {formatMessage({id: 'BundlesScreen.Expand.bullets'}, htmlHandlers)}
                </ul>
              </div>
            </div>
            <div className={styles['bundle-description']}>
              <div className={styles['bundle-image']}>
                <img src={ExpandBundleImg2x} alt="Expand platform"/>
              </div>
              <div className={styles['bundle-description-wrapper']}>
                <div className={`${styles['bundle-description-title']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.subtitle'})}
                </div>
                <div className={`${styles['bundle-description-body']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.body'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.motherboard'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.motherboard.description'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.cpu'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.cpu.description'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.ram'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.ram.description'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.storage'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Expand.storage.description'})}
                </div>
                <div className={styles['bundle-ask-price-container']}>
                  <button className={`${styles['bundle-ask-price']} Rubik-20pt`} onClick={() => {
                    ReactGA.set({ dimension5: REQUEST_PRICE_EXPAND });
                    showModal(RequestModal, {
                      selectedBusiness: {
                        type: 2,
                        title: 'Expand',
                      }
                    })
                  }}>
                    {formatMessage({id: 'BundlesScreen.RequestPrice'})}
                  </button>
                </div>
              </div>
            </div>
          </>
        ) }
        { selectedBundle === 'enterprise' && (
          <>
            <div className={styles.bundle}>
              <div className={`${styles['bundle-meta']} Rubik-26pt`}>
                {formatMessage({id: 'BundlesScreen.Enterprise.meta'})}
              </div>
              <div className={`${styles['bundle-bullets']} Rubik-26pt`}>
                <ul>
                  {formatMessage({id: 'BundlesScreen.Enterprise.bullets'}, htmlHandlers)}
                </ul>
              </div>
            </div>
            <div className={styles['bundle-description']}>
              <div className={styles['bundle-image']}>
                <img src={EnterpriseBundleImg2x} alt="Enterprise platform"/>
              </div>
              <div className={styles['bundle-description-wrapper']}>
                <div className={`${styles['bundle-description-title']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.subtitle'})}
                </div>
                <div className={`${styles['bundle-description-body']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.body'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.motherboard'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.motherboard.description'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.cpu'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.cpu.description'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.ram'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.ram.description'})}
                </div>
                <div className={`${styles['bundle-description-item']} Rubik-26pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.storage'})}
                </div>
                <div className={`${styles['bundle-description-item-desc']} Rubik-20pt`}>
                  {formatMessage({id: 'BundlesScreen.Enterprise.storage.description'})}
                </div>
                <div className={styles['bundle-ask-price-container']}>
                  <button className={`${styles['bundle-ask-price']} Rubik-20pt`} onClick={() => {
                    ReactGA.set({ dimension6: REQUEST_PRICE_ENTERPRISE });
                    showModal(RequestModal, {
                      selectedBusiness: {
                        type: 3,
                        title: 'Entry-level Enterprise',
                      }
                    })
                  }}>
                    {formatMessage({id: 'BundlesScreen.RequestPrice'})}
                  </button>
                </div>
              </div>
            </div>
          </>
        ) }
      </MediaQuery>
    </div>
  );
};

export default BundlesScreen;
